<template>
  <ul>
    <li>
      <a href="#!">Módulo {{ moduloName }}</a>
    </li>
    <li
      v-for="(item, index) in permissionGrantedModuloMenu"
      v-bind:key="index"
      class="sidenav-modulo-menuitem"
    >
      <a
        v-if="item.isLink"
        v-bind:href="item.href || '#!'"
        target="_blank"
        class="sidenav-close"
        v-on:click.prevent="item.href ? null : item.onClick"
        >{{ item.content }}</a
      >
      <BaseRouterLink v-else class="sidenav-close" v-bind="item">{{
        item.content
      }}</BaseRouterLink>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TheHeaderSidenavModuloMenu",
  inheritAttrs: false,
  props: {
    moduloName: {
      type: String,
      required: true
    },
    moduloMenu: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    permissionGrantedModuloMenu() {
      return this.moduloMenu.filter(item =>
        this.$authorization.hasAnyPermission(item.permissions)
      );
    }
  }
};
</script>

<style scoped>
li.sidenav-modulo-menuitem a {
  font-weight: 400;
  padding: 0 37.5px 0 45px;
}
</style>
